import { Component, OnInit } from '@angular/core';
import { TeamService } from '../../services/team.service';
import { Team } from '../../models/team';
import { User } from '../../models';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-team-admin',
  templateUrl: './team-admin.component.html',
  styleUrls: ['./team-admin.component.scss']
})
export class TeamAdminComponent implements OnInit {
  waitOn = {init: true, action: false};
  editTarget = null;
  searchInput = "";
  view = "defaultView";

  views = {
    defaultView: "defaultView",
    createTeamForm: "createTeamForm",
    editTeamForm: "editTeamForm"
  };

  teams: Array<Team> = [];

  searchForm: UntypedFormGroup = this.formBuilder.group({
    name: ["", Validators.required]
  });

  constructor(
    private teamService: TeamService,
    private toastrService: ToastrService,
    private formBuilder: UntypedFormBuilder
  ) { }

  ngOnInit(): void {
    this.getTeams();
  }

  getTeams() {
    this.teamService.getAll().subscribe({
      next: teams => {
        this.teams = teams;
        (this.teams || []).sort((a, b) => {
          const nameA = a.lead.lastName || '';
          const nameB = b.lead.lastName || '';
          return nameA > nameB ? 1 : nameA < nameB ? -1 : 0;
        });
        this.waitOn.init = false;
      },
      error: error => {
        this.waitOn.init = false;
        this.toastrService.error(error);
      }
    });
  }

  createTeam(event: Team) {
    if (confirm("Create Team?") === false) {
      return;
    }
    this.waitOn.action = true;
    console.log(event);
    this.teamService.create(event).subscribe({
      next: (team: Team) => {
        this.teams.push(team);
        this.toastrService.success(`Team created.`);
        this.waitOn.action = false;
        this.onSelectView("defaultView");
      },
      error: error => {
        this.toastrService.error(error);
        this.waitOn.action = false;
      }
    });
  }

  editTeam(event: Team) {
    if (confirm("Edit Team?") === false) {
      return;
    }
    this.waitOn.action = true;
    this.teamService.update(event).subscribe({
      next: (team: Team) => {
        Object.assign(this.editTarget, team);
        this.toastrService.success(`Team \"${team.id}\" Updated.`);
        this.waitOn.action = false;
        this.onSelectView("defaultView");
      },
      error: error => {
        this.toastrService.error(error);
        this.waitOn.action = false;
      }
    });
  }

  deleteTeam(team: Team) {
    if (confirm(`Delete Team?`) === false) {
      return;
    }

    this.waitOn.action = true;
    this.teamService.delete(team).subscribe({
      next: () => {
        let existingTeamId: number;
        for (let i = 0; i < this.teams.length; i++) {
          const existingTeam = this.teams[ i ];
          if (existingTeam.id === team.id) {
            existingTeamId = existingTeam.id;
            this.teams.splice(i, 1);
            break;
          }
        }
        this.toastrService.success(`Deleted ${team.lead.firstName} ${team.lead.lastName}'s team.`);
        this.waitOn.action = false;
      },
      error: error => {
        this.toastrService.error(error);
        this.waitOn.action = false;
      }
    });
  }

  onSelectView(viewType: string) {
    this.view = this.views[ viewType ];
  }

  onSelectEditTarget(team: Team) {
    this.editTarget = team;
    this.onSelectView("editTeamForm");
  }

  onCancelEditTarget() {
    this.onSelectView("defaultView");
    this.editTarget = null;
  }

  onSearch(formValues) {
    const sanitizedInput = formValues.name.trim().toLowerCase();
    this.searchInput = sanitizedInput;
  }

  onClearSearch() {
    this.searchForm.patchValue({name: ""});
    this.searchInput = "";
  }

  searchMatch(user: User): boolean {
    if (this.searchInput === "") {
      return true;
    }

    const name = `${user.firstName} ${user.lastName}`.toLowerCase();
    return name.includes(this.searchInput);
  }
}
